module.exports = __webpack_public_path__ + "static/profile-3829db1e83207657cb360e2b95d7c19a.jpg";